import React from "react";
import { Navigate } from "react-router-dom";
import { useAgentAccountDetails } from "shared/hooks/common";
import { DEFAULT_LANDING_PAGES, DEFAULT_DASHBOARD_FALLBACK } from "shared/constants/Constants";

/**
 * Renders for the root path "/".
 * - No token or accountDetails → redirect to /login
 * - Has token → redirect to role's default dashboard page
 */
export default function DefaultRoute() {
  const { agentRole } = useAgentAccountDetails();
  const defaultPath =
    agentRole && DEFAULT_LANDING_PAGES[agentRole] != null
      ? DEFAULT_LANDING_PAGES[agentRole]
      : DEFAULT_DASHBOARD_FALLBACK;

  if (
    process.env.NODE_ENV !== "production" &&
    agentRole &&
    DEFAULT_LANDING_PAGES[agentRole] == null
  ) {
    console.warn(
      `[DefaultRoute] Role "${agentRole}" is not in DEFAULT_LANDING_PAGES; add an entry in shared/constants/Constants.js. Using fallback: ${DEFAULT_DASHBOARD_FALLBACK}`
    );
  }

  return <Navigate to={`/dashboard/${defaultPath}`} replace />;
}
